// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-timeline {
  padding-left: 50px;
}
.timelinestatus {
  font-size: 16px;
}
.order-timeline .timelineList {
  margin: 0px !important;
  padding: 0px !important;
}
.completed {
  background-color: #000;
}
.orderRow {
  font-size: 14px;
}
.timelineLoader {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991px) {
  .order-timeline {
    padding-left: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/timeline/Timeline.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".order-timeline {\n  padding-left: 50px;\n}\n.timelinestatus {\n  font-size: 16px;\n}\n.order-timeline .timelineList {\n  margin: 0px !important;\n  padding: 0px !important;\n}\n.completed {\n  background-color: #000;\n}\n.orderRow {\n  font-size: 14px;\n}\n.timelineLoader {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 991px) {\n  .order-timeline {\n    padding-left: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
